import { BaseEntity } from 'common-shared';

export class RoleModel extends BaseEntity {
  Name: string;
  Comment: string;
  Privileges: Array<string>;

  static CreateDefault(init?: Partial<RoleModel>) {
    return Object.assign(new RoleModel(), {} as RoleModel, init);
  }
}
